import React from 'react';
import { Card, Row, Col, Table, Typography, Button } from 'antd';
import Title from '../../component/title';
import useTable from '../../component/table';
import MyForm from './form';

const Kelas = props => {
    const [, tb] = useTable('/class', {})
    const [currentReligion, setCurrentReligion] = React.useState(null);
    const [add, setAdd] = React.useState(false);

    const onRow = (record) => {
        return {
            onClick: () => {
                setCurrentReligion(record);
                setAdd(false);
            }
        }
    }

    const addClicked = () => {
        setCurrentReligion(null);
        setAdd(true);
    }

    return (
        <Card title={<Title title={"Master kelas"} actions={<Button type="primary" onClick={addClicked}>Tambah</Button>} />}>
            <Row style={{ height: '100%' }} gutter={32}>
                <Col span={14}>
                    <Card title={"Daftar kelas"}>
                        <Table {...tb.tableProps} onRow={onRow}>
                            <Table.Column dataIndex="grade.name" title="Grade" />
                            <Table.Column dataIndex="name" title="Nama"
                                {...tb.columnProps({ key: 'name', hint: 'Cari nama' })} />
                            <Table.Column dataIndex="type" title="Tipe" render={(t) => {
                                switch (t) {
                                    case 0: {
                                        return 'Normal';
                                    }
                                    case 1: {
                                        return 'Pendaftaran'
                                    }
                                    default: return 'Unknown'
                                }
                            }}
                                {...tb.columnProps({ key: 'type', type: 'radio', options: [{ text: 'Normal', value: 0 }, { text: 'Pendaftaran', value: 1 }] })} />
                        </Table>
                    </Card>
                </Col>
                <Col span={10}>
                    <Card title={add ? "Tambah kelas" : "Edit kelas"}>
                        {currentReligion === null && !add && <Typography.Text disabled>Silakan pilih kelas ajaran pada tabel untuk edit</Typography.Text>}
                        {(currentReligion !== null || add) && <MyForm record={currentReligion} edit={!add} onSuccess={() => {
                            setAdd(false);
                            setCurrentReligion(null);
                            tb.fetchData();
                        }} />}
                    </Card>
                </Col>
            </Row>
        </Card >
    )
}

export default Kelas;